import React from 'react'
import SEO from 'src/components/common/SEO'
import NBCDispute from 'src/components/template/facts'
import { useAnalyticsInit } from 'src/modules/hooks/useAnalyticsInit'
import useTrackScroll from 'src/modules/hooks/useTrackScroll'
export default (props) => {
  useAnalyticsInit({ lang: 'en', market: 'all' })
  useTrackScroll()
  return (
    <>
      <SEO
        lang="en"
        market="all"
        image="https://assets-imgx.fubo.tv/marketing/lp/images/meta/your_voice_matters.png?auto=format,compress"
        title="We Are Fighting to Keep Your Bill Low"
        description="NBCU has had repeated public disputes with other distributors and is now using the same tactics against Fubo — weaponizing their sports content to force bad deals on you."
      />
      <NBCDispute />
    </>
  )
}
